import * as api from '@owl-nest/api-client/next'

export type Role = (typeof ROLE)[keyof typeof ROLE]

/**
 * Ordered roles : highest number for highest role
 */
export const ROLE = {
  STAFF: 5,
  OWNER: 4,
  COORDINATOR: 3,
  EDITOR: 2,
  MODERATOR: 1,
  BIG_NOBOD: 0,
} as const

export function getRole(role: api.UserRole, isStaff: boolean): Role {
  if (isStaff) {
    return ROLE.STAFF
  }
  switch (role) {
    case api.UserRole.Owner: {
      return ROLE.OWNER
    }
    case api.UserRole.Coordinator: {
      return ROLE.COORDINATOR
    }
    case api.UserRole.Editor: {
      return ROLE.EDITOR
    }
    case api.UserRole.Moderator: {
      return ROLE.MODERATOR
    }
    default: {
      return ROLE.BIG_NOBOD
    }
  }
}
